const arr = '1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM'

export const randomStr = (len: number): string => {
  let ans = ''
  for (let i = len; i > 0; i--) {
    ans += arr[Math.floor(Math.random() * arr.length)]
  }
  return ans
}
